let cookieAuth: any = null;
let pushNotifToken: any = null;
let solvedProblems = 0;
const LS_NOTIF_TOKEN_KEY = 'pushNotificationToken';

export default {
  data: {
    getPushNotifToken: () => localStorage.getItem(LS_NOTIF_TOKEN_KEY) || pushNotifToken,
    getCookie: () => localStorage.getItem('cookieAuth'),
    getSolvedProblems: () => solvedProblems,
  },
  setPushNotifToken: (t: string) => {
    pushNotifToken = t;
    localStorage.setItem(LS_NOTIF_TOKEN_KEY, t);
  },
  setCookie: (c: any) => {
    cookieAuth = c;
    localStorage.setItem('cookieAuth', c);
  },
  resetCookie: () => {
    cookieAuth = null;
    localStorage.removeItem('cookieAuth');
  },
  incrementSolvenProblems: () => {
    solvedProblems+=1;
  },
}
